module.exports = new __parcel__URL__("fear.bbb2fe30.png").toString();